export default __webpack_public_path__ + "static/media/vec.00066cab.jpg";